// extracted by mini-css-extract-plugin
export var bright = "social-list-module--bright--e1gVP";
export var dark = "social-list-module--dark--WIKNA";
export var facebook = "social-list-module--facebook--7tX+n";
export var findUsAlso = "social-list-module--findUsAlso--9XZt0";
export var headerBox = "social-list-module--header-box--waQAF";
export var icons = "social-list-module--icons--TfOCw";
export var instagram = "social-list-module--instagram--5WP6l";
export var link = "social-list-module--link--AqJya";
export var twitter = "social-list-module--twitter--Mz-Fr";